/**
 * The staff dashboard's URL: how a change to its query is merged, and the
 * full links it hands out.
 *
 * Links are always a full path (/teacher-dashboard?…), never a bare "?…"
 * or "#…": the page's <base href="/"> (public/index.html) resolves a bare
 * one against the site root, so a new tab, or a plain click on a "#" link,
 * would land on the landing page instead.
 */

/** The dashboard's route (router.js). */
export const DASHBOARD_PATH = '/teacher-dashboard';

// What belongs to the open student: the paper review (?paper=), the quiz
// review (?quiz=), the profile's tab (?ptab=) and the Activity section it
// was moved to (?section=).
const STUDENT_PARAMS = ['paper', 'quiz', 'ptab', 'section'];

/**
 * `prev` (URLSearchParams) with `patch` applied: a null or empty value
 * deletes its key. A patch that sets `student` (opening, closing or
 * switching student) also drops the student's own parameters, unless the
 * patch sets them itself.
 */
export function mergeParams(prev, patch) {
  const next = new URLSearchParams(prev);
  Object.entries(patch).forEach(([k, v]) => {
    if (v == null || v === '') next.delete(k);
    else next.set(k, v);
  });
  if ('student' in patch) STUDENT_PARAMS.filter((k) => !(k in patch)).forEach((k) => next.delete(k));
  return next;
}

/** The full URL of the paper review `ref` from the dashboard at `params`, for its link's href. */
export function paperReviewHref(params, ref) {
  const next = new URLSearchParams(params);
  next.set('paper', ref);
  return `${DASHBOARD_PATH}?${next.toString()}`;
}

/**
 * The full URL of the custom quiz review `sessionId` (a Quiz generator
 * row's session_id), for its link's href. A paper review open at `params`
 * is closed: one review is open at a time.
 */
export function quizReviewHref(params, sessionId) {
  const next = new URLSearchParams(params);
  next.delete('paper');
  next.set('quiz', sessionId);
  return `${DASHBOARD_PATH}?${next.toString()}`;
}
